/* eslint-disable */ 
import { URL } from '../../../config'
import { getRequest } from '../../../utils/functions/httpRequest'

export const getTeamPowerPointsBySeason = function (seasonId,teamId,weekNo) 
{
    const endpoint = `/${seasonId}/${teamId}/${weekNo}/teamPowerPointsBySeason`
    const rankingURL = `${URL.ranking}${endpoint}` 
    return getRequest(rankingURL)
}


// WEBPACK FOOTER //
// ./src/components/pages/api/getTeamPowerPointsBySeason.js